"use strict";
ResponsiveHTMLTemplate.registerHTMLTemplate(Object.assign(Object.assign({}, ResponsiveHTMLTemplate.base), { name: "Loader", forDevice: { IsDefault: true }, buildLoader(additionalClasses, id) {
        var attrID = id ? `id="${id}"` : "";
        return `
            <div class="preloader ${additionalClasses || ""}" ${attrID}>
                <div class="preloader-spinner preloader-container">
                    <div class="preloader-spinner preloader-fill">
                        <div class="preloader-clipper left">
                            <div class="preloader-circle"></div>
                        </div>
                        <div class="preloader-gap-patch">
                            <div class="preloader-circle"></div>
                        </div>
                        <div class="preloader-clipper right">
                            <div class="preloader-circle"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    },
    buildLoaderWithText(settings) {
        var __html = "", defaults = {
            wrapperClasses: "",
            textClasses: "",
            text: "",
            loaderCondition: true,
            loaderClasses: "",
            loaderID: ""
        }, options = Object.assign(Object.assign({}, defaults), settings);
        __html += `
            <div class="preloader-with-text ${options.wrapperClasses}">`;
        if (options.loaderCondition) {
            __html += this.buildLoader(options.loaderClasses, options.loaderID);
        }
        __html += `
                <div class="preloader-text ${options.textClasses}" data-uat="preloader-text">
                    ${options.text}
                </div>
            </div>
        `;
        return __html;
    } }));
//# sourceMappingURL=TDefaultLoader.js.map